
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_mp1x5_6",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_mp1x5_12",
  "pagination-button": "awsui_pagination-button_14rmt_mp1x5_30",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_mp1x5_35",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_mp1x5_38",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_mp1x5_42",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_mp1x5_45",
  "tabs-tab": "awsui_tabs-tab_14rmt_mp1x5_50",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_mp1x5_62",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_mp1x5_78",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_mp1x5_135",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_mp1x5_164",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_mp1x5_171",
  "root": "awsui_root_14rmt_mp1x5_175",
  "tabs": "awsui_tabs_14rmt_mp1x5_6",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_mp1x5_191",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_mp1x5_195",
  "tabs-content": "awsui_tabs-content_14rmt_mp1x5_191",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_mp1x5_203"
};
  